import Vue from "vue";
import VueEvents from 'vue-events';
import store from "./vuex/store";
import actions from "./vuex/action_types";
import axios from "./plugins/axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import Vuelidate from "vuelidate";
import VTooltip from 'v-tooltip';
import filters from './services/Filters.js';
import GlobalMethods from './global-methods';
import BootstrapVue, {BDropdown, BDropdownItem, BModal, ButtonPlugin, ModalPlugin} from "bootstrap-vue";
import vSelect from 'vue-select';
import CKEditor from '@ckeditor/ckeditor5-vue2';


import 'vue-select/dist/vue-select.css';
import {fetchTranslations} from "./services/TranslationsFetch";
import translations from "./plugins/translation";
import translationsText from "./translationsText";

import './components';
import './views';

Vue.use(translations, {store: store});
Vue.use(VueEvents);
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.use(ModalPlugin);
Vue.use(ButtonPlugin);
Vue.use(VTooltip);


Vue.use(CKEditor);
Vue.use(BootstrapVue);

Vue.component("b-dropdown", BDropdown);
Vue.component("b-dropdown-item", BDropdownItem);
Vue.component("b-modal", BModal);
Vue.component('v-select', vSelect);

Vue.filter('percent', filters.percent);
Vue.filter('money', filters.localizeMoney);
Vue.filter('floatMoney', filters.floatMoney);
Vue.filter('capitalize', filters.capitalize);
Vue.filter('percentParticipation', filters.percentParticipation);
Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
    return this;
};

$.holdReady(true);
document.addEventListener("DOMContentLoaded", async () => {
    await fetchTranslations(store, translationsText);
    window.vm = new Vue({
        el: "#app",
        mounted: function () {
            $.holdReady(false);
            if($('#logged-user-id').val() > 0){
                this.$store.dispatch(actions.FETCH_USER_INFO);
                this.$store.dispatch(actions.FETCH_SERVER_INFO);
            }

        },
        methods: GlobalMethods,
        store,
    });
});

